import { ref } from "vue"
import { defineStore } from "pinia"

export const useUserStore = defineStore("user", () => {
	const user = ref(null)
	const actingAsUser = ref(null)
	const uuid = ref("1")

	function setUser(u) {
		user.value = u
	}

	function setActingAsUser(u) {
		actingAsUser.value = u
		// if (!u) {
		// 	localStorage.removeItem("actingAsUser")
		// } else {
		// 	localStorage.setItem(
		// 		"actingAsUser",
		// 		JSON.stringify({ _id: u._id.toString() })
		// 	)
		// }

		// uuid.value = crypto.randomUUID()
		if (u) {
			uuid.value = crypto.randomUUID()
		} else {
			uuid.value = "1"
		}
	}

	function isViewingUser() {
		return actingAsUser.value !== null
	}

	//save acting as user
	// function saveActingAsUser() {
	// 	localStorage.setItem("actingAsUser", JSON.stringify(actingAsUser.value))
	// }

	//load acting as user
	// function loadActingAsUser() {
	// 	const storedUser = localStorage.getItem("actingAsUser")
	// 	if (storedUser) {
	// 		actingAsUser.value = JSON.parse(storedUser)
	// 	}
	// }

	return {
		uuid,
		user,
		actingAsUser,
		setUser,
		setActingAsUser,
		isViewingUser,
	}
})
